import { render, staticRenderFns } from "./VotingNotes.vue?vue&type=template&id=02da3fcb&"
import script from "./VotingNotes.vue?vue&type=script&lang=js&"
export * from "./VotingNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports